import "./contact-us-button.scss";
import { Button } from "../../../../components/inputs/button/button";

interface IContactUsButton {
    onClick: () => void;
}

const ContactUsButton: React.FC<IContactUsButton> = ({onClick}) => {
    return (
        <div className="contact-us-button">
            <Button onClick={onClick} text="contact us" />
        </div>
    )
}

export default ContactUsButton;
